/**
 * Handles animated elements on the site.
 *
 * Usage example:
 * ==============
 * let animations = new Animations('.animation', 'animated');
 */


 jQuery( document ).ready(function() {

   jQuery( ".readmore" ).click(function() {
 	 	jQuery(".interview" ).fadeIn();
		jQuery(".readmore" ).fadeOut();
		jQuery(".intro" ).addClass('restloaded');
	});

  jQuery( ".person" ).each(function() {
    jQuery(jQuery(this)).mouseover(function() {
      jQuery(jQuery(this)).addClass('show-person-info');
    });

    jQuery(jQuery(this)).mouseout(function() {
      jQuery(jQuery(this)).removeClass('show-person-info');
    });
  });


  



 });



export default class Animations {

	/**
	 * Constructor method.
	 *
	 * @param  {string} selector Class selector for elements that will be animated
	 * @param  {string} animated Class name for animated elements
	 * @param  {bool}   repeat   Removes the animated class when the element is not in the viewport
	 * @return {undefined}
	 */
	constructor(selector, animated, repeat) {
		this.selector = selector;
		this.animated = animated;
		this.repeat   = (repeat !== true) ? false : true;
		this.paused   = false;

		this.reindex();

		window.addEventListener('scroll',    e => this.update());
		window.addEventListener('touchmove', e => this.update());
	}

	/**
	 * Reindexes the animated elements.
	 *
	 * @return {undefined}
	 */
	reindex() {
		this.elements = document.querySelectorAll(`${this.selector}:not(${this.animated})`);
		for (let el of this.elements) {
			let offset         = el.getAttribute('data-offset');
			el.animationOffset = (offset) ? offset : 0;
		}
		this.update();
	}

	/**
	 * Handles animated elements in the viewport.
	 *
	 * @return {undefined}
	 */
	update() {
		if (!this.paused) {
			for (let el of this.elements) {
				if (this.viewport(el, el.animationOffset)) {
					el.classList.add(this.animated);
				} else if (this.repeat) {
					el.classList.remove(this.animated);
				}
			}
		}
	}

	/**
	 * Checks if an element is in the current browser viewport.
	 *
	 * @param  {el} el HTML element that needs to be checked
	 * @return {bool}
	 */
	viewport(el, offset) {
		let rect = el.getBoundingClientRect();
		if (rect.top < window.innerHeight - offset && rect.bottom > 0 + offset) {
			return true;
		} else {
			return false;
		}
	}

}



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/library/Animations.js